import { createClaimRequest } from './helper';
export const getClaimZdbList = createClaimRequest({
    route: '/claim/zdb',
    method: 'get',
    source: 'data',
});
